import { render, staticRenderFns } from "./intro_platform.vue?vue&type=template&id=76de50e0&"
import script from "./intro_platform.vue?vue&type=script&lang=js&"
export * from "./intro_platform.vue?vue&type=script&lang=js&"
import style0 from "./intro_platform.vue?vue&type=style&index=0&id=76de50e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports